export default __webpack_public_path__ + "static/media/mm140.843e61e8.webp";